import { setPrimaryColor } from '@/plugins/vuetify'

const state = {
  urlLogo: '@/assets/logo-azul.png',
  urlLogoInverse: '@/assets/logo-azul.png',
  faviconUrl: null,
  colorTheme: '#006bf2',
  workspaceName: 'Limer',
  tipoFaturamentoLink: null,
  emailFaturamentoLink: null,
  cnpjPagadorLink: null,
}

const mutations = {
  setCustomizacao(state, { url_logo, url_logo_inverse, color_theme, name, tipo_faturamento, email_faturamento, cnpj_pagador }) {
    state.urlLogo = url_logo || state.urlLogo
    state.urlLogoInverse = url_logo_inverse || state.urlLogoInverse
    state.faviconUrl = url_logo || state.faviconUrl
    state.colorTheme = color_theme || state.colorTheme
    state.workspaceName = name || state.workspaceName
    state.tipoFaturamentoLink = tipo_faturamento || state.tipoFaturamentoLink
    state.emailFaturamentoLink = email_faturamento || state.emailFaturamentoLink
    state.cnpjPagadorLink = cnpj_pagador || state.cnpjPagadorLink

    if (color_theme) {
      setPrimaryColor(color_theme)
    }
  },
}

const getters = {
  urlLogo: state => state.urlLogo,
  urlLogoInverse: state => state.urlLogoInverse,
  faviconUrl: state => state.faviconUrl,
  colorTheme: state => state.colorTheme,
  workspaceName: state => state.workspaceName,
  tipoFaturamentoLink: state => state.tipoFaturamentoLink,
  emailFaturamentoLink: state => state.emailFaturamentoLink,
  cnpjPagadorLink: state => state.cnpjPagadorLink,
  skipFaturamentoStep: state => state.tipoFaturamentoLink === 'parceiro',
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
}
